import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

// Assets (PCS Corporate Design)
import pcsLogo from './assets/PCS_Logo_CMYK.svg';
import pcsLogoNegativ from './assets/PCS_Logo_CMYK_negativ.svg';

// Components
import PublicStatus from './components/public/PublicStatus';
import AdminDashboard from './components/admin/AdminDashboard';
import SystemMonitoring from './components/system/SystemMonitoring';
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AccountSettings from './components/auth/AccountSettings';
import Documentation from './components/docs/Documentation';
import SecurityDashboard from './pages/SecurityDashboard';

function NavigationBar() {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Navbar expand="lg" className="navbar-pcs">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={pcsLogo} alt="PCS Systemtechnik" className="brand-logo" />
          <span className="brand-divider" />
          <span className="brand-text">
            DEXIOS <span className="brand-sub">Monitoring</span>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/">Status</Nav.Link>

            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/admin">Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/security">Security Scanner</Nav.Link>
                <Nav.Link as={Link} to="/system">System</Nav.Link>
                <Nav.Link as={Link} to="/docs">Dokumentation</Nav.Link>

                <NavDropdown title={user?.username || 'User'} id="user-dropdown" align="end">
                  <NavDropdown.Item disabled>
                    <small className="text-muted">{user?.email}</small>
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={Link} to="/account">
                    Account-Einstellungen
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    Abmelden
                  </NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <Nav.Link as={Link} to="/login">Login</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <NavigationBar />

          {/* Routes */}
          <Container className="mt-4">
            <Routes>
              <Route path="/" element={<PublicStatus />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/system"
                element={
                  <ProtectedRoute>
                    <SystemMonitoring />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <AccountSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/docs"
                element={
                  <ProtectedRoute>
                    <Documentation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/security"
                element={
                  <ProtectedRoute>
                    <SecurityDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Container>

          {/* Footer */}
          <footer className="footer mt-5">
            <Container>
              <div className="footer-inner">
                <img src={pcsLogoNegativ} alt="PCS Systemtechnik" className="footer-logo" />
                <small>
                  © 2026 PCS Systemtechnik GmbH · DEXIOS Monitoring v1.1.4
                </small>
                <nav className="footer-links">
                  <a href="https://www.pcs.com/impressum/" target="_blank" rel="noopener noreferrer">
                    Impressum
                  </a>
                  <a href="https://www.pcs.com/datenschutz/" target="_blank" rel="noopener noreferrer">
                    Datenschutz
                  </a>
                </nav>
                <span className="footer-claim">Zeit für Sicherheit.</span>
              </div>
            </Container>
          </footer>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
